import { FormlyFieldConfig } from '@ngx-formly/core';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseProp',
  pure: false
})
export class ParsePropPipe implements PipeTransform {
  transform(prop: any, field: FormlyFieldConfig): unknown {
    if (typeof prop === 'function') {
      return prop(field.model, field);
    }
    return prop;
  }
}
